import { createSlice } from "@reduxjs/toolkit";

export interface ActivityInDetailModal {
  id: string | number;
  open: boolean;
  activityName: string;
  activeTab: string;
  onClose?: "openProjectModal" | "openPhaseModal";
  phaseResponse: {
    id: number | null;
    name: string;
    status: string;
    startDate: string;
    endDate: string;
  };
  projectResponse: {
    id: number | null;
    status: string;
    name: string;
    isLocked?: boolean;
    lockedBy?: number;
    lockedByName?: string;
    updatedDate?: string;
    updatedBy?: number;
    updatedByName?: string;
    plannedStartDate?: string;
    plannedEndDate?: string;
  };
  extra: {
    status: string;
    createdAt?: string;
    createdByUserName?: string;
    startDate?: string;
    endDate?: string;
    ownerName?: string;
    ownerId?: number;
    originalActivityOwnerName?: string;
    originalActivityOwnerId?: number;
    reassignedReason?: string;
  };
  allowEdit?: boolean;
  allowAdd?: boolean;
}
const initialState: { data: ActivityInDetailModal } = {
  data: {
    id: "",
    open: false,
    activityName: "",
    activeTab: "tasks",
    onClose: "openPhaseModal",
    phaseResponse: {
      id: null,
      name: "",
      status: "",
      startDate: "",
      endDate: "",
    },
    projectResponse: {
      id: null,
      status: "",
      name: "",
    },
    extra: {
      status: "",
    },
    allowEdit: true,
    allowAdd: true,
  },
};

export const ActivityInDetailModalSlice = createSlice({
  name: "ActivityInDetailModalSlice",
  initialState,
  reducers: {
    updateActivityInDetailModalSlice(state, action) {
      state.data = { ...state.data, ...action.payload };
    },
    resetActivityInDetailModalSlice(state) {
      state.data = initialState.data;
    },
  },
});

export const {
  updateActivityInDetailModalSlice,
  resetActivityInDetailModalSlice,
} = ActivityInDetailModalSlice.actions;
